import { Button } from "@/components/ui/button";
import { EmptyField } from "@/components/ui/empty-field";
import { AlertTriangle } from "lucide-react";

export interface QuoteCardProps {
  id: string;
  from: string;
  to: string;
  vehicle: string;
  value: string;
  expires: string;
  alert?: boolean;
  onFinish?: () => void;
  cveCodigo?: string;
}

export default function QuoteCard({
  id,
  from,
  to,
  vehicle,
  value,
  expires,
  alert = false,
  onFinish,
  cveCodigo,
}: QuoteCardProps) {
  return (
    <>
      <div className="space-y-3 md:space-y-4">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
          <span className="font-semibold">
            Cotação nº&nbsp;{cveCodigo || id}
          </span>

          <div className="flex items-center gap-2 text-sm font-medium">
            <span>
              Expira em: {expires || <EmptyField>Não informado</EmptyField>}
            </span>
            {alert && <AlertTriangle className="w-4 h-4 text-red-600" />}
          </div>
        </div>

        <div className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 lg:grid-cols-[repeat(4,minmax(0,1fr))_auto] gap-3 md:gap-4 text-sm">
          <div>
            <span className="block font-semibold">De:</span>
            <span className="text-n-text-neutral">
              {from || <EmptyField>Origem não informada</EmptyField>}
            </span>
          </div>

          <div>
            <span className="block font-semibold">Para:</span>
            <span className="text-n-text-neutral">
              {to || <EmptyField>Destino não informado</EmptyField>}
            </span>
          </div>

          <div>
            <span className="block font-semibold">Veículo:</span>
            <span className="text-n-text-neutral">
              {vehicle || <EmptyField>Veículo não informado</EmptyField>}
            </span>
          </div>

          <div>
            <span className="block font-semibold">Valor</span>
            <span className="text-n-text-neutral">
              {value || <EmptyField>Valor não informado</EmptyField>}
            </span>
          </div>

          <div className="xs:col-span-2 md:col-span-1 lg:col-auto flex items-center justify-start md:justify-end pt-2 md:pt-0">
            <Button onClick={onFinish} className=" font-semibold ">
              Finalizar
            </Button>
          </div>
        </div>
      </div>

      <div className="h-[1px] md:h-[2px] bg-gray-300 my-3 md:my-4 last:hidden" />
    </>
  );
}
